import React, { PropsWithChildren, useState } from 'react'
import { CreateVideoType } from 'constant/videoTypes'
import classNames from 'classnames'
interface VideoPlayerProps {
  path: string
  onClick: () => void
  createVideoType: CreateVideoType
  noHeight?: boolean
}
export const VideoPlayer = ({
  path,
  onClick,
  createVideoType,
}: PropsWithChildren<VideoPlayerProps>) => {
  const [duration, setDuration] = useState<string | null>(null)

  function formatSecondsToTimeString(seconds: number): string {
    const min = Math.floor(seconds / 60)
    const sec = Math.floor(seconds % 60)
    const paddedMin = String(min).padStart(2, '0')
    const paddedSec = String(sec).padStart(2, '0')
    return `${paddedMin}:${paddedSec}`
  }
  const handleLoadedMetadata = (e: React.SyntheticEvent<HTMLVideoElement>) => {
    const duration = e.currentTarget.duration
    console.log(duration)

    setDuration(formatSecondsToTimeString(duration))
  }
  return (
    <>
      <div
        className={classNames(
          'w-[85px] overflow-hidden bg-black cursor-pointer flex justify-center items-center rounded-[4px]',
          {
            'h-[151px] ': createVideoType === CreateVideoType.PRODUCT_SHORT,
            'h-[85px] ': createVideoType !== CreateVideoType.PRODUCT_SHORT,
          }
        )}
        onClick={onClick}
      >
        <video
          src={path}
          className={classNames('', {
            ' rounded-[4px] h-[85px]':
              createVideoType !== CreateVideoType.PRODUCT_SHORT,
            ' rounded-[4px] w-[85px]':
              createVideoType === CreateVideoType.PRODUCT_SHORT,
          })}
          onLoadedMetadata={(e) => handleLoadedMetadata(e)}
          playsInline
          loop
          muted
        />
      </div>
      <div className="flex justify-center">
        {' '}
        <span className=" text-[14px]">{duration}</span>
      </div>
    </>
  )
}
